import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zyctbsexhf: FaireBrandEntity = {
  token: "b_zyctbsexhf",
  type: "brand",
  name: "Shady Front",
  location: "Toms River, NJ, USA",
  isTopShop: true,
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
